export const REVIEWER_GROUP_SCOPES = {
  ORG: 'org',
  PERSONAL: 'personal'
} as const;

export type ReviewerGroupScope = (typeof REVIEWER_GROUP_SCOPES)[keyof typeof REVIEWER_GROUP_SCOPES];

export interface ReviewerGroupColor {
  key: string;
  label: string;
  hex: string;
}

// The swatch palette a group is created with; the API rejects any other value.
export const REVIEWER_GROUP_COLORS: readonly ReviewerGroupColor[] = Object.freeze([
  { key: 'red', label: 'Red', hex: '#ef4444' },
  { key: 'blue', label: 'Blue', hex: '#2563eb' },
  { key: 'amber', label: 'Amber', hex: '#f59e0b' },
  { key: 'green', label: 'Green', hex: '#16a34a' },
  { key: 'purple', label: 'Purple', hex: '#9333ea' },
  { key: 'pink', label: 'Pink', hex: '#db2777' },
  { key: 'teal', label: 'Teal', hex: '#0d9488' },
  { key: 'indigo', label: 'Indigo', hex: '#4338ca' },
  { key: 'orange', label: 'Orange', hex: '#f97316' },
  { key: 'gray', label: 'Gray', hex: '#6b7280' }
]);

export const REVIEWER_GROUP_COLOR_HEXES: readonly string[] = Object.freeze(
  REVIEWER_GROUP_COLORS.map(color => color.hex)
);

// Why a requested member was not added.
export const REVIEWER_GROUP_MEMBER_SKIP_REASONS = {
  ALREADY_MEMBER: 'already_member',
  DUPLICATE: 'duplicate'
} as const;

export type ReviewerGroupMemberSkipReason =
  (typeof REVIEWER_GROUP_MEMBER_SKIP_REASONS)[keyof typeof REVIEWER_GROUP_MEMBER_SKIP_REASONS];

export const REVIEWER_GROUP_NAME_MAX_LENGTH = 80;
export const REVIEWER_GROUP_MEMBERS_MAX = 200;
export const REVIEWER_GROUP_MEMBERS_MAX_PER_REQUEST = 100;

// Scope rides on the community group's tags.
export const REVIEWER_GROUP_SCOPE_TAGS: Readonly<Record<ReviewerGroupScope, string>> =
  Object.freeze({
    [REVIEWER_GROUP_SCOPES.ORG]: 'reviewer_scope:org',
    [REVIEWER_GROUP_SCOPES.PERSONAL]: 'reviewer_scope:personal'
  });
